export default __webpack_public_path__ + "static/media/undraw_Coding_re_iv62.a1151eba.svg";